module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLnVpbi1jb252LWxpc3Qgew0KCWhlaWdodDogMTAwJTsNCgl3aWR0aDogMTAwJTsNCglvdmVyZmxvdzogYXV0bzsNCiAgICBvdmVyZmxvdy14OiBoaWRkZW47DQp9DQo="


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationList/ConversationList.scss
// module id = 2476
// module chunks = 0